import './NavItem/NavItem.scss';
import './CollapsibleNavList/CollapsibleNavList.scss';
import './NavSecondary/NavSecondary.scss';
import './Breadcrumb/Breadcrumb.scss';
import './TeaserNavigation/TeaserNavigation.scss';
import { bool2str } from '@bopf/util';

const resetCollapsibleNavStatus = nav => {
    Array.prototype.forEach.call(nav.querySelectorAll('.nav-item--with-toggle'), e => {
        e.nextElementSibling.setAttribute('aria-expanded', bool2str(e.classList.contains('nav-item--active-rootline')));
    });
};

(e => e && e.addEventListener('open', () => {
    resetCollapsibleNavStatus(e);
}))(document.querySelector('.js-header__navigation__mobile'));

Array.from(document.querySelectorAll('.nav-list-toggle')).forEach(e => e.addEventListener('click', () => {
    e.setAttribute('aria-expanded', e.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    e.style.maxHeight = e.previousSibling.clientHeight + 'px';
}));



const findCurrentLi = () => {
    const currentLink = document.querySelectorAll('.nav-item--current');
    const rootLineLink = document.querySelectorAll('.nav-item--active-rootline');
    for ( let i = 0; i < currentLink.length; i++ ) {
        currentLink[i].parentNode.classList.add('nav-li-item--current');
    }
    for ( let i = 0; i < rootLineLink.length; i++ ) {
        rootLineLink[i].parentNode.classList.add('nav-li-item--active-rootline');
    }
};

(function (callback) {
    // in case the document is already rendered
    if (document.readyState !== 'loading') callback();
    // modern browsers
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
    // IE <= 8
    else document.attachEvent('onreadystatechange', function () {
        if (document.readyState === 'complete') callback();
    });
})(
    function () {
        findCurrentLi();
    }
);
